<mat-form-field class="field-medium">
    <mat-label>Date des DMG</mat-label>
    <input matInput (dateChange)="dmgDate = $event.value" [matDatepicker]="pickerDate">
    <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
    <mat-datepicker #pickerDate></mat-datepicker>
</mat-form-field>
<mat-form-field class="field-medium">
    <mat-label>OA</mat-label>
    <input matInput [(ngModel)]="dmgOA" name="searchoa">
</mat-form-field>
<button mat-stroked-button (click)="requestDMG()">Demande des DMG</button>
<button mat-stroked-button (click)="getMsg()">Visualiser les réponses</button>
<div style="overflow-y:scroll;height:50vw;">
    <table mat-table matSort [dataSource]="messages?.lists" class="full-width">
        <ng-container matColumnDef="io">
            <mat-header-cell *matHeaderCellDef> OA </mat-header-cell>
            <mat-cell *matCellDef="let element; let index = index" style="display:block;width:100%;">
                <div>
                    <button style="float:left;" mat-icon-button aria-label="edit" (click)="ioDisplay.set(element.list.reference,!(ioDisplay.get(element.list.reference)))">
                        <fa-icon *ngIf="!ioDisplay.get(element.list.reference)" [icon]="['fas', 'chevron-square-right']" class="action-button" size="lg"></fa-icon>
                        <fa-icon *ngIf="ioDisplay.get(element.list.reference)" [icon]="['fas', 'chevron-square-down']" class="action-button" size="lg"></fa-icon>
                    </button>
                    {{element.list.io}}
                </div>
                <table *ngIf="ioDisplay.get(element.list.reference)" mat-table matSort [dataSource]="element.inscriptions" class="full-width">
                    <ng-container matColumnDef="lastname">
                        <mat-header-cell *matHeaderCellDef> Nom </mat-header-cell>
                        <mat-cell *matCellDef="let inscription; let index = index" style="display:block;">
                            {{inscription.inscription.lastName}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="firstname">
                        <mat-header-cell *matHeaderCellDef> Prénom </mat-header-cell>
                        <mat-cell *matCellDef="let inscription; let index = index" style="display:block;">
                            {{inscription.inscription.firstName}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="from">
                        <mat-header-cell *matHeaderCellDef> Depuis </mat-header-cell>
                        <mat-cell *matCellDef="let inscription; let index = index" style="display:block;">
                            {{inscription.fromAsString}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="to">
                        <mat-header-cell *matHeaderCellDef> Jusque </mat-header-cell>
                        <mat-cell *matCellDef="let inscription; let index = index" style="display:block;">
                            {{inscription.toAsString}}
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="columnsMessage"></mat-header-row>
                    <mat-row *matRowDef="let inscriptionRow; columns: columnsMessage;"></mat-row>
                </table>

            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
            <mat-cell *matCellDef="let element; let index = index" style="display:block;">
                <button mat-stroked-button (click)="confirm(element.list.valueHash)">Confirmer</button>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="columnsIo"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsIo;"></mat-row>
    </table>
</div>